<template>
  <section class="">
          <slot></slot>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
              <section class="">
                <h2 class="title">{{ $t('Cambiar contraseña') }}</h2>
                <ValidationProvider
                  name="Contraseña"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-field :label="$t('Contraseña actual')">
                    <b-input v-model="formData.oldPassword"></b-input>
                  </b-field>
                  <p v-show="errors.length" class="help is-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
                <ValidationProvider
                  name="NewPassword"
                  rules="required|password:@NewPasswordConfirm"
                  v-slot="{ errors }"
                >
                  <b-field :label="$t('Nueva Contraseña')">
                    <b-input v-model="formData.newPassword"></b-input>
                  </b-field>
                  <p v-show="errors.length" class="help is-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
                <ValidationProvider
                  name="NewPasswordConfirm"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-field :label="$t('Confirmar Nueva Contraseña')">
                    <b-input v-model="formData.newPasswordConfirm"></b-input>
                  </b-field>
                  <p v-show="errors.length" class="help is-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </section>
              <div class="has-text-centered">
                <b-button
                  size="is-large"
                  native-type="submit"
                  type="is-primary"
                  >{{ $t('Enviar') }}</b-button
                >
              </div>
            </form>
          </ValidationObserver>

  </section>
</template>
<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      formData: {
        oldPassword: null,
        newPassword: null,
        newPasswordConfirm: null
      }
    }
  },

  methods: {
    validateBeforeSubmit() {
      this.$emit('formSubmit', this.formData)
    }
  }
}
</script>

<style scoped></style>
